var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB2Sunset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73 38v4H3v-4h70zm-17-7a2 2 0 002 2h8a2 2 0 000-4h-8a2 2 0 00-2 2zm-2.5-12.7l5.7-5.7a2.1 2.1 0 000-2.6 2 2 0 00-2.8-.2l-5.7 5.7a2 2 0 102.8 2.8zM24.18 33h4.05a9.72 9.72 0 01-.23-2.1 10 10 0 0120 0 9.72 9.72 0 01-.23 2.1h4c.133-.693.21-1.395.23-2.1a14 14 0 00-28 0c.004.704.064 1.406.18 2.1zM40 46h-4v18.08h-8l10 10.84 10-10.84h-8V46zm-2-33a2 2 0 002-2V3a2 2 0 10-4 0v8a2 2 0 002 2zm-15.5 5.3a2 2 0 102.8-2.8l-5.7-5.7a2.1 2.1 0 00-2.6 0 2 2 0 00-.2 2.8l5.7 5.7zM10 33h8a2 2 0 000-4h-8a2 2 0 100 4z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/B2_Sunset.b6940f63.svg";
export { SvgB2Sunset as ReactComponent };